module.exports = __webpack_public_path__ + "img/sSearch.0f014e54.svg";